import { Header } from "@/component/Header"
import { masterSchemaSlice } from "@/slice/masterSchemaSlice"
import { RootState } from "@/store"
import { gqlClient } from "@/util/graphql"
import { Box } from "@mui/material"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Table } from "./Table"
import { useDropZone } from "./useDropZone"

export const TableScreen = () => {
	const dispatch = useDispatch()

	React.useEffect(() => {
		gqlClient()
			.masterSchema()
			.then((res) => {
				dispatch(masterSchemaSlice.actions.setData(res))
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const currentTableName = useSelector((state: RootState) => {
		return state.masterSchema.currentTableName
	})

	const { getRootProps, DropZone } = useDropZone(currentTableName ?? "")

	if (!currentTableName) return <></>
	return (
		<>
			<Header />
			<Box sx={{ marginTop: "48px" }} {...getRootProps()}>
				<Table tableName={currentTableName} />
				{DropZone}
			</Box>
		</>
	)
}
